import { ControlIcon, PlusIcon } from "@theprelude/ds";
import { Node, NodeProps } from "@xyflow/react";
import { DisconnectedControlDataPoint } from "@/queries/control-monitor";
import { NodeBase } from "./node-base";

export type DisconnectedControlNodeType = Node<
  DisconnectedControlDataPoint,
  DisconnectedControlDataPoint["type"]
>;

export const DisconnectedControlNode = ({
  data,
}: NodeProps<DisconnectedControlNodeType>) => (
  <NodeBase
    nodeId={data.id}
    name={data.name}
    icon={<ControlIcon control={data.control} />}
    hasParent
    hasChildren={data.children.length > 0}
  >
    <div className="flex w-full items-center gap-1 border-t border-stroke-table px-2 py-1 text-xs text-secondary-foreground dark:border-stroke-line">
      <PlusIcon /> Connect
    </div>
  </NodeBase>
);
